/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Vaibhav Lodhiya",
  title: "Hi, I'm Vaibhav Lodhiya",
  subTitle: emoji(
    "From code to clarity — I engineer AI-powered tools, BI dashboards, and end-to-end data pipelines that create measurable business impact. 📊🤖"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1kXgWkMHArk_LrXXDFs2PpW49UKyMelE4/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/VaibhavLodhia",
  linkedin: "https://www.linkedin.com/in/vaibhav-lodhiya/",
  gmail: "vaibhavlodhiya30@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: emoji("Data Scientist & AI Developer focused on building intelligent tools, dashboards, and automation pipelines that drive decisions 📊🚀"),
  skills: [
    emoji("⚡ Design interactive dashboards in Power BI and Tableau to uncover business trends"),
    emoji("⚡ Automate workflows using Python, SQL, Airflow, and cloud services like AWS"),
    emoji("⚡ Build AI/LLM-based tools using IBM Granite, Meta LLaMA, and Streamlit")
  ],
  softwareSkills: [
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "SQL", fontAwesomeClassname: "fas fa-database" },
    { skillName: "Power BI", fontAwesomeClassname: "fas fa-chart-bar" },
    { skillName: "AWS", fontAwesomeClassname: "fab fa-aws" },
    { skillName: "React.js", fontAwesomeClassname: "fab fa-react" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "Node.js", fontAwesomeClassname: "fab fa-node" },
    { skillName: "Excel", fontAwesomeClassname: "fas fa-file-excel" },
    { skillName: "GitHub", fontAwesomeClassname: "fab fa-github" },
    { skillName: "Streamlit", fontAwesomeClassname: "fas fa-stream" }  // custom or substitute icon
  ],
  display: true
};


// const skillsSection = {
//   title: "What I do",
//   subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
//   skills: [
//     emoji(
//       "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
//     ),
//     emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
//     emoji(
//       "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
//     )
//   ],

//   /* Make Sure to include correct Font Awesome Classname to view your icon
// https://fontawesome.com/icons?d=gallery */

//   softwareSkills: [
//     {
//       skillName: "html-5",
//       fontAwesomeClassname: "fab fa-html5"
//     },
//     {
//       skillName: "css3",
//       fontAwesomeClassname: "fab fa-css3-alt"
//     },
//     {
//       skillName: "sass",
//       fontAwesomeClassname: "fab fa-sass"
//     },
//     {
//       skillName: "JavaScript",
//       fontAwesomeClassname: "fab fa-js"
//     },
//     {
//       skillName: "reactjs",
//       fontAwesomeClassname: "fab fa-react"
//     },
//     {
//       skillName: "nodejs",
//       fontAwesomeClassname: "fab fa-node"
//     },
//     {
//       skillName: "swift",
//       fontAwesomeClassname: "fab fa-swift"
//     },
//     {
//       skillName: "npm",
//       fontAwesomeClassname: "fab fa-npm"
//     },
//     {
//       skillName: "sql-database",
//       fontAwesomeClassname: "fas fa-database"
//     },
//     {
//       skillName: "aws",
//       fontAwesomeClassname: "fab fa-aws"
//     },
//     {
//       skillName: "firebase",
//       fontAwesomeClassname: "fas fa-fire"
//     },
//     {
//       skillName: "python",
//       fontAwesomeClassname: "fab fa-python"
//     },
//     {
//       skillName: "docker",
//       fontAwesomeClassname: "fab fa-docker"
//     }
//   ],
//   display: true // Set false to hide this section, defaults to true
// };

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Indiana University",
      logo: require("./assets/images/logo-iu.jpg"),
      subHeader: "Master of Science in Data Science",
      duration: "August 2022 - May 2024",
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "MIT World Peace University",
      logo: require("./assets/images/mit-logo.jpg"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "August 2018 - May 2022",
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Data Analytics",
      progressPercentage: "90%"
    },
    {
      Stack: "AI/ML & LLMs",
      progressPercentage: "85%"
    },
    {
      Stack: "ETL & Automation",
      progressPercentage: "80%"
    },
    {
      Stack: "Frontend/Design",
      progressPercentage: "70%"
    },
    {
      Stack: "Cloud/DevOps (AWS, Streamlit)",
      progressPercentage: "65%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Developer",
      company: "Technoid LLC",
      companylogo: require("./assets/images/technoid_logo.png"),
      date: "Jan 2025 – Present",
      desc: "Designed a full-stack AI pipeline using React, IBM Watson STT, LangChain, and GPT-4 to reduce meeting recap load by 50%, analyzed e-commerce conversion funnels via SQL-based cohort models to boost retention by 25%, and collaborated with stakeholders on A/B tests to improve campaign ROI and efficiency.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit" 
      // ]
    },
    {
      role: "AI Software Engineer",
      company: "Tracker",
      companylogo: require("./assets/images/Tracker_logo.png"),
      date: "Aug 2024 – Jan 2025",
      desc: "Trained a YOLOv8 model on 5,000+ annotated images to detect fire and smoke damage, used GPT-4 for cost estimation and damage localization, built Power Automate workflows for CRM updates to reduce issue response time by 30%, and optimized ETL with performant GraphQL resolvers."
    },
    {
      role: "Data Scientist",
      company: "HCN",
      companylogo: require("./assets/images/HCN_logo.png"),
      date: "May 2024 – Nov 2024",
      desc: "Enhanced digital strategy and online efficiency by 40% for 10+ Indiana businesses, built automated forecasting pipelines using SQL and Python ETL, and delivered Tableau dashboards analyzing FDA drug approvals to increase data visibility by 30%."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/BI1.png"),
      projectName: "Business Intelligence",
      projectDesc: "Designed a Power BI report to enable quick business insights to clients across all 3 markets which includes marketing, sales, finance, and supply chain. Operated on data set having more than 1000K records to derive useful business insights on 5 different dashboards. Incorporated Power query and DAX for creating calculated columns and measures.",
      footerLink: [
        {
          name: "See Live",
          url: "https://app.powerbi.com/view?r=eyJrIjoiYTliNDUxMTgtNTcxMC00ZjM1LWExYzUtODIzMjRjYjM5OWIwIiwidCI6ImM2ZTU0OWIzLTVmNDUtNDAzMi1hYWU5LWQ0MjQ0ZGM1YjJjNCJ9"
        },
        {
          name: "Source Code",
          url: "https://github.com/VaibhavLodhia/Business-Insights-360"
        }
      ]
    },
    {
      image: require("./assets/images/BI2.png"),
      projectName: "AI-Grader",
      projectDesc: "Harnessed GenerativeAI techniques in natural language processing to generate automated responses to grading prompts using IBM Granite LLM to automate grading, enhancing consistency and efficiency in student assignment evaluations.",
      footerLink: [
        {
          name: "See Live",
          url: "https://aigrader.streamlit.app/"
        },
        {
          name: "Source Code",
          url: "https://github.com/VaibhavLodhia/Ai_Grader"
        }
      ]
    },
    {
      image: require("./assets/images/BI3.png"),
      projectName: "AI SQLScribe",
      projectDesc: "Streamlined text-to-SQL translation with clear instructions with Meta Llama LLM, context provision, examples, and Retrieval Augmented Generation, making data analysis more intuitive and interactive for healthcare professionals.",
      footerLink: [
        {
          name: "See Live",
          url: "https://sqlscribe.streamlit.app"
        },
        {
          name: "Source Code",
          url: "https://github.com/VaibhavLodhia/SQLScribe"
        }
      ]
    },
    {
      image: require("./assets/images/BI4.png"),
      projectName: "Revenue Insights in Hospitality Domain",
      projectDesc: "Prepped a dashboard on Power BI which had Hotel booking data with over 9000 bookings where property's revenue and ratings were demonstrated by key metrics. Applied Do-nut chart to visualize revenue generated by Business and Luxury Category.",
      footerLink: [
        {
          name: "See Live",
          url: "https://app.powerbi.com/view?r=eyJrIjoiNzRmMDUzM2QtOGRkZC00MDRhLWE0YjEtNGE3OGUzMjJjN2FiIiwidCI6ImM2ZTU0OWIzLTVmNDUtNDAzMi1hYWU5LWQ0MjQ0ZGM1YjJjNCJ9"
        },
        {
          name: "Source Code",
          url: "https://github.com/VaibhavLodhia/Revenue_Insights_in_Hospitality_Domain"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include achievements, awards, and notable accomplishments

const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle:
    "Achievements, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "CRNY Data Visualization Contest Winner",
      subtitle:
        "Clinched 1st Place in the CRNY Data Visualization Contest (out of 1000+ participants) by developing interactive dashboards with Power BI and SQL-based data transformation. Applied regression models to analyze 3,000+ survey responses, deriving key insights for non-profit decision-making.",
      image: require("./assets/images/CRNY.png"),
      imageAlt: "CRNY Logo",
      footerLink: []
    },
    {
      title: "Hacktoberfest Contributor",
      subtitle:
        "Contributed to 5 GitHub repositories during active participation in Hacktoberfest, showcasing a strong commitment.",
      image: require("./assets/images/Hactoberfest.png"),
      imageAlt: "Hacktoberfest Logo",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false// Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+18123619872",
  email_address: "vaibhavlodhiya30@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
